import { BaseLookup } from "./base.lookup";

export class LeadTypesLookup extends BaseLookup {
  
    // Values
    static readonly MATCHED = new LeadTypesLookup('1', 'Matched');
    static readonly DIRECT = new LeadTypesLookup('2', 'Direct');
    static readonly CALL = new LeadTypesLookup('3', 'Call');
  
  }